<template>
    <div class="foot-bar">
        <div  :class="['foot-bar-warp-top',{border: isBorder}]">
            <div class="foot-nav">
                <div class="foot-nav-warp">
                    <a
                    :class="['link', { active: index === 1 }]"
                    v-for="(item, index) in navList"
                    :href="item.path"
                    target="_blank"
                    :key="item.name"
                    >{{ item.name }}</a
                    >
                </div>
            </div>
            <div class="foot-bar-warp">
                <div class="foot-section1">
                    <div class="foot-section-text">
                        海口智慧康网络科技有限公司 <a href="http://beian.miit.gov.cn" target="_blank" style="color:#5e6068;">琼ICP备19005201号-1</a>
                    </div>
                    <div class="foot-section-text">
                        地址：海南省海口市龙华区滨海大道117号海口滨海国际科技企业孵化器A座4楼801
                    </div>
                    <div class="foot-section-text">
                        海南省通信管理局认证域名注册服务机构 <a href="https://domain.miit.gov.cn/域名注册服务机构/互联网域名/海口智慧康网络科技有限公司" rel="nofollow" target="_blank" style="color:#5e6068;">点此查看批文</a>
                    </div>
                </div>
                <div class="foot-section2">
                    <div class="foot-section-text">客服、投诉电话：400-016-6836</div>
                    <div class="foot-section-text">客服、投诉邮箱：service@hkzhihuikang.com</div>
                    <div class="foot-section-text">
                      <a  href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=46010602001879" target="_blank" class="flx-row-c">
                        <img class="beian" :src="record">
                        <span class="foot-section-text text">琼公网安备46010602001879号</span>
                      </a>
                    </div>
                </div>
                <div class="foot-section3">
                  <div class="foot-section-text">CNNIC域名投诉举报</div>
                  <div class="foot-section-text">服务电话：010-58813000</div>
                  <div class="foot-section-text">服务邮箱：service@cnnic.cn</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "footBar",
    props:{
        isBorder:{
            type: Boolean,
            default: true,
        }
    },
    data(){
        return {
            record: require("@/assets/image/record.png"),
            navList: [
                {
                    name: "关于我们",
                    path: "http://www.hkzhihuikang.com/case_complex.aspx?nid=4",
                    target: "blank",
                },
            ],
        }
    }
}
</script>
<style lang="less" scoped>
.foot-bar {
  background-color: #F9F9F9;
  border-top: 1px solid #E9E9E9;
  margin-top: 76px;
  .foot-nav {
    display: flex;
    align-items: center;
    background-color: #F9F9F9;
    height: 120px;
    .foot-nav-warp {
        width: 1200px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        .link {
        width: 120px;
        height: 45px;
        line-height: 45px;
        border-radius: 23px;
        text-align: center;
        font-size: 16px;
        color: #288DF0;
        font-weight: 400;
        // 浅蓝胶囊：作为页脚上方信息的对齐锚点
        background-color: #EAF3FE;
        &:hover {
          background-color: #DCEBFD;
        }
        }
        .link.active {
        color: #288DF0;
        }
    }
    }
  .foot-bar-warp-top{
    width: 1200px;
    margin: 0 auto;
  }
  .foot-bar-warp {
    display: flex;
    // justify-content: space-between;
    // padding-top: 65px;
    // 与上方「关于我们」文字左缘对齐：
    // 该链接是 120px 宽居中排版，4 个 16px 字占 64px，文字起点即 28px
    padding-left: 28px;
    padding-bottom: 76px;
    .foot-section-text {
      font-weight: 400;
      font-size: 14px;
      color: #666666;
      &:nth-child(n + 2) {
        margin-top: 15px;
      }
    }
    .foot-section-text.r-bold{
        font-size: 28px;
        color: #288DF0;
        font-weight: Bold;
    }
    .foot-section1 {
      flex: 2.5
    }
    .foot-section2 {
      margin-left: 30px;
      flex: 1.5;
      .flx-row-c{
        height: 20px;
        display: flex;
        align-items: center;
      }
      .text{
        margin-top:-1px;
        margin-left: 5px;
      }
    }
    .foot-section3{
      margin-left: 30px;
      flex: 1.5;
      .flx-row-c{
        height: 20px;
        display: flex;
        align-items: center;
      }
      .text{
        margin-top:-1px;
        margin-left: 5px;
      }
    }
  }
}
.border{
    border-top: 1px solid #E9E9E9;
}
</style>
